module.exports = __webpack_public_path__ + "assets/img/smartTV-module4-4.815d66c5.jpg";